import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import parse from 'html-react-parser';

import '../../scss/broadcast.scss';
import getCommonResponse from '../actions/Common';
import RefreshToken from '../actions/RefreshToken';

function Preview(props) {
    const {id, brand, project} = useParams();
    const navigate = useNavigate();
    const [html, setHtml] = useState('');
    const resButtons = ["Desktop", "Tab-Portrait", "Tab-Landscape", "Phone"];
    const [buttonIndex, setButtonIndex] = useState(0);
    const ref = useRef()
    const [width, setWidth] = useState("0px");
    const [publicUrl, setPublicUrl] = useState(null);

    useEffect(() => {
        if(brand == undefined) {
            function CallAPI(accesstoken) {
                if(accesstoken === '') {
                    navigate('/login');
                } else if(accesstoken === 'noToken') {
                    navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
                } else {
                     const URL = `/api/project/htmlPreviewDetails/${id}`;
                    getCommonResponse.GetDetailsWithToken(URL, accesstoken, (response) => {  
                        if(response.status == 200) {
                            setHtml((decodeURIComponent(response.data.details)));
                        } else if(response.status == 401) {
                            navigate("/login")
                        }
                    });
                }
            }
            RefreshToken((accesstoken) => CallAPI(accesstoken));
        } else {
            const URL = `/api/project/publicPreviewDetails/${id}`;
            getCommonResponse.GetDetailsWithApiKey(URL, (response) => {  
                if(response.status == 200) {
                    if(response.data.data.projectId == project) {
                        setPublicUrl(response.data.data.publicUrl);
                    }
                } else if(response.status == 401) {
                    navigate("/login")
                }
            });
        }
    }, [])

    const handleResponsive = (index) => {
        setButtonIndex(index);
    }

    useEffect(() => {
        if(brand == undefined) {
            var iFrame = document.getElementById('previewiFrame');
            var previewFrame = document.getElementById('previewFrame');
            if(ref.current.classList.contains('phone')) {
                var scrolbarWidth = 20;
                var scrollWidth = iFrame.contentWindow.document.body.scrollWidth;
                var totalwidth = scrollWidth+scrolbarWidth;
                if(totalwidth > 520) {
                    totalwidth = 520;
                }
                setWidth(`${totalwidth}px`)
            } else {
                setWidth("0px")
            }
        }
    }, [buttonIndex])

    return (
        <div>
            {brand == undefined && 
            <div className='preview-container'>
                <div className="res-btn-container">
                    <div className='res-btn-group'>
                        {resButtons.map((item, i) => {
                            return(
                                <button className={buttonIndex == i ? `res-selected-btn` : `res-btn`} onClick={() => handleResponsive(i)}>{item}</button>
                            )
                        })}
                    </div>
                </div>
                <div ref={ref} id="previewFrame" style={{minWidth: width}} className={`htmlcontent ${buttonIndex == 0 ? 'desktop' : ''} 
                    ${buttonIndex == 1 ? 'tab-portrait' : ''} ${buttonIndex == 2 ? 'tab-landscape' : ''} ${buttonIndex == 3 ? 'phone' : ''}`}>
                    <iframe id="previewiFrame" srcDoc={html} style={{width: "100%", height: "100vh", display: "block", overflow: "hidden"}}></iframe>
                </div>
            </div>}
            {publicUrl != null && 
                <iframe src={publicUrl} style={{width: "100%", height: "100vh", display: "block", overflow: "hidden"}}></iframe>
            }
        </div>
    );
}

export default Preview;